import { Language } from '../../lang/Language'
import { GameState, GameTag } from './GameState.types'

export class GameStates {
  public static PreGame = new GameState(GameTag.pregame, Language.strings.states.game.pregame)
  public static ReadyToPlay = new GameState(GameTag.readytoplay, Language.strings.states.game.readytoplay)
  public static Playing = new GameState(GameTag.playing, Language.strings.states.game.playing)
  public static Sleep = new GameState(GameTag.sleep, Language.strings.states.game.sleep)
  public static Reset = new GameState(GameTag.reset, Language.strings.states.game.reset)
  public static Paused = new GameState(GameTag.paused, Language.strings.states.game.paused)
  public static Finished = new GameState(GameTag.finished, Language.strings.states.game.finished)

  static isPreGame(s: GameState) {
    return s.tag === GameTag.pregame
  }

  static isReadyToPlay(s: GameState) {
    return s.tag === GameTag.readytoplay
  }

  static isPlaying(s: GameState) {
    return s.tag === GameTag.playing
  }

  static isSleep(s: GameState) {
    return s.tag === GameTag.sleep
  }

  static isReset(s: GameState) {
    return s.tag === GameTag.reset
  }

  static isPaused(s: GameState) {
    return s.tag === GameTag.paused
  }

  static isFinished(s: GameState) {
    return s.tag === GameTag.finished
  }
}
